import styled from 'styled-components';

export const RescheduleInfoMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l35} ${props.theme.spacing.large.l35};
    `
);

export const InfoBlockHeadWrap = styled.div(
    props => `
        width:100%;
        dispaly: flex;
        flex-direction: column;
    `
);

export const InfoBlockHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        padding-bottom: ${props.theme.spacing.small.s3};
    `
);

export const InfoBlockSubText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.green.base};
    `
);

export const RefundBtnWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top: ${props.theme.spacing.large.l30};
        cursor: ${props.disabled ? '' : 'pointer'};
        pointer-events: ${props.disabled ? 'none' : ''};
        opacity: ${props.disabled ? '0.3' : '1'};
    `
);

export const RefundBtn = styled.button(
    props => `
        outline: none;
        border: none;
        border-radius: 4rem;
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l30};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform: uppercase;
        align-self: flex-end;
        cursor: pointer;
    `
);